// Local area pages for SEO. Each entry generates a route at
// /appliance-repair-{slug}-nj and serves a localized landing page.

export const COUNTIES = [
  {
    slug: "gloucester-county",
    name: "Gloucester County",
    type: "county",
    intro:
      "Major Appliance Repair has been the go-to appliance repair service for Gloucester County homeowners for over a decade. From Washington Township to Sewell to Wenonah and Woodbury, our technicians arrive on time and fix your appliance the right way the first time.",
    nearby: ["Washington Township", "Sewell", "Wenonah", "Woodbury", "Sicklerville"],
    zip: "08080",
  },
  {
    slug: "camden-county",
    name: "Camden County",
    type: "county",
    intro:
      "Camden County residents trust Major Appliance Repair for fast, honest appliance service. We serve Cherry Hill, Voorhees, Sicklerville, Marlton-area neighborhoods, and the surrounding communities with same-day or next-day appointments.",
    nearby: ["Cherry Hill", "Voorhees", "Sicklerville"],
    zip: "08043",
  },
  {
    slug: "burlington-county",
    name: "North Burlington County",
    type: "county",
    intro:
      "We proudly serve North Burlington County, including Mount Laurel, Marlton, and the surrounding areas. Our certified technicians repair every major appliance brand with a 30-day parts and labor warranty.",
    nearby: ["Mount Laurel", "Marlton"],
    zip: "08054",
  },
];

export const CITIES = [
  {
    slug: "voorhees",
    name: "Voorhees",
    county: "Camden County",
    type: "city",
    intro:
      "Voorhees Township residents rely on Major Appliance Repair for refrigerator, washer, dryer, oven, and dishwasher repair. Our shop is based right in Voorhees at 1099 White Horse Rd, so we can usually be at your door the same day.",
    zip: "08043",
  },
  {
    slug: "cherry-hill",
    name: "Cherry Hill",
    county: "Camden County",
    type: "city",
    intro:
      "Cherry Hill homeowners count on Major Appliance Repair for fast, professional appliance service. We service every major brand and model, with same-day or next-day appointments and a 30-day warranty on every repair.",
    zip: "08002",
  },
  {
    slug: "sicklerville",
    name: "Sicklerville",
    county: "Camden County",
    type: "city",
    intro:
      "Sicklerville families call us when their refrigerator stops cooling or their washer won't drain. We bring common parts on every truck so most appliance repairs in Sicklerville are completed in one visit.",
    zip: "08081",
  },
  {
    slug: "mount-laurel",
    name: "Mount Laurel",
    county: "Burlington County",
    type: "city",
    intro:
      "Mount Laurel residents trust our local team for honest, upfront appliance repair. We diagnose every appliance with a flat $99 service call fee ($109 for refrigerators) — and waive it entirely when you proceed with the repair.",
    zip: "08054",
  },
  {
    slug: "marlton",
    name: "Marlton",
    county: "Burlington County",
    type: "city",
    intro:
      "Marlton homeowners get fast appliance repair from a fully licensed and insured local team. We service every major brand and stand behind every repair with a 30-day parts and labor warranty.",
    zip: "08053",
  },
  {
    slug: "sewell",
    name: "Sewell",
    county: "Gloucester County",
    type: "city",
    intro:
      "Need appliance repair in Sewell? Our technicians serve Sewell and the surrounding Washington Township area every day of the week. Same-day and next-day appointments available.",
    zip: "08080",
  },
  {
    slug: "washington-township",
    name: "Washington Township",
    county: "Gloucester County",
    type: "city",
    intro:
      "Washington Township homeowners rely on Major Appliance Repair for refrigerators, dishwashers, washers, dryers, and more. We diagnose the issue, give you an upfront price, and complete most repairs in a single visit.",
    zip: "08080",
  },
  {
    slug: "wenonah",
    name: "Wenonah",
    county: "Gloucester County",
    type: "city",
    intro:
      "Wenonah residents get prompt, professional appliance repair from our certified local team. From cooling problems to leaks to non-starting units, we fix it right the first time.",
    zip: "08090",
  },
  {
    slug: "woodbury",
    name: "Woodbury",
    county: "Gloucester County",
    type: "city",
    intro:
      "Woodbury homeowners trust Major Appliance Repair for fast turnaround and honest pricing. We service all major appliance brands and models, with same-day or next-day appointments available.",
    zip: "08096",
  },
];

export const ALL_AREAS = [...COUNTIES, ...CITIES];

export const getAreaBySlug = (slug) =>
  ALL_AREAS.find((a) => a.slug === slug);
